import styled from "styled-components";

import { Row } from "@components/Row";

export const QuestionHeader = styled(Row)`
  > svg {
    flex-shrink: 0;
  }
`;

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
`;
